import jwt from "jsonwebtoken";
import { fail } from "./shared";

/**
 * Chat trusts one thing: the end-user token webmail issued after the mail
 * server verified a password. This service never sees a password, and never
 * opens an IMAP connection.
 */
const SECRET = process.env.END_USER_JWT_SECRET ?? "";
export const END_USER_COOKIE = "py_user";

export interface EndUser {
  sub: string;
  address: string;
  domain: string;
  displayName: string;
  clientId: string | null;
  avatarSeed: number;
  kind: "mailbox";
}

export function requireEndUser(req: any, res: any, next: any) {
  const token = req.cookies?.[END_USER_COOKIE];
  if (!token) {
    return fail(res, 401, "NO_SESSION", "Sign in to your mailbox to use chat.");
  }
  try {
    const payload = jwt.verify(token, SECRET) as EndUser;
    if (payload.kind !== "mailbox") throw new Error("wrong token kind");
    req.me = payload;
    next();
  } catch {
    return fail(res, 401, "SESSION_EXPIRED", "Your session has ended. Please sign in again.");
  }
}

/** The company directory, used to check who someone is allowed to talk to. */
export async function directory(domain: string): Promise<Array<{ id: string; address: string; displayName: string; avatarSeed: number }>> {
  const base = process.env.AUTH_INTERNAL_URL ?? "http://localhost:4001";
  const key = process.env.INTERNAL_API_KEY ?? "";
  const r = await fetch(`${base}/internal/mailbox-users?domain=${encodeURIComponent(domain)}`, {
    headers: { "x-internal-key": key },
  });
  if (!r.ok) throw new Error(`directory HTTP ${r.status}`);
  const data = (await r.json()) as any;
  return data.people;
}
